(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDeleteController',ScriptsReleasesDeleteController);

    ScriptsReleasesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScriptsReleases'];

    function ScriptsReleasesDeleteController($uibModalInstance, entity, ScriptsReleases) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            ScriptsReleases.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
